import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faBarcode,
  faCalendar,
  faClock,
  faMinus,
  faMoneyBillWave,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  orderListDetailApi,
  orderRepoartsApi,
} from "../../Api/SupplierServices";
import { separate } from "../../Functions/NumberSeprator";
import toEnglishDigits from "../../Functions/PersionToEn";
import { errorToast } from "../../Utils/Toast/Toast";
import DatePickerInRange from "../DatePickerInRange/DatePickerInRange";
import Factor from "../Factor/Factor";
import LoadingComponet from "../LoadingComponet/LoadingComponet";
import Modal from "../Modal/Modal";
import Style from "./OrderHistory.module.css";
import { splitJalaliDateTime } from "../../Functions/convertDateToJalali";

const OrderHistory = () => {
  const [orderID, setOrderID] = useState();
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });

  const minimumDate = {
    year: parseInt(startTime.split("-")[0]),
    month: parseInt(startTime.split("-")[1]),
    day: parseInt(startTime.split("-")[2]),
  };

  const maximumDate = {
    year: parseInt(endTime.split("-")[0]),
    month: parseInt(endTime.split("-")[1]),
    day: parseInt(endTime.split("-")[2]),
  };

  const [purchased, setPurchased] = useState(false);
  const [ordersRepoart, setOrdersRepoart] = useState();
  const [orderListDetails, setOrderListDetails] = useState();

  useEffect(() => {
    getOrderRepoart();
  }, []);

  const getOrderListsDetail = async (id) => {
    const data = await orderListDetailApi(id);
    setOrderListDetails(data);
  };

  const FactorListHandler = (id) => {
    setOrderID(id);
    setOrderListDetails(undefined);
    setPurchased(true);
    getOrderListsDetail(id);
  };

  const getOrderRepoart = (date) => {
    let dateRange = {
      start_date:
        date === undefined
          ? ""
          : `${date.from.year}-${date.from.month}-${date.from.day}`,
      end_date:
        date === undefined
          ? ""
          : `${date.to.year}-${date.to.month}-${date.to.day}`,
    };
    orderRepoartsApi(dateRange, (succ) => {
      if (succ.status === 1) {
        setOrdersRepoart(succ);
        setStartTime(toEnglishDigits(succ.duration.start));
        setEndTime(toEnglishDigits(succ.duration.end));
      } else {
        errorToast(succ.message);
      }
    });
  };
  
  let loadingHandler = null;
  if (ordersRepoart === undefined) {
    loadingHandler = <LoadingComponet />;
  } else {
    const displayedOrders = Array.isArray(ordersRepoart?.orders) ? [...ordersRepoart.orders].reverse() : [];
    loadingHandler = displayedOrders.map((item) => {
      const { date: orderDate, time: orderTime } = splitJalaliDateTime(item.date);
      return (
        <ul key={item.id} className={Style.EachPart__ul}>
          <li className={Style.EachPart__li__Date}>
            <div>
              <FontAwesomeIcon icon={faCalendar} />
              <span>{orderDate}</span>
            </div>
            <div>
              <FontAwesomeIcon icon={faClock} />
              <span>{orderTime}</span>
            </div>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon icon={faBarcode} />
            کد پیگیری: <span>{item.id}</span>
          </li>
          <li className={Style.EachPart__li}>
            <FontAwesomeIcon
              icon={faQuestionCircle}
            //   style={{ color: "#c20c64" }}
            />
            {item.status === "3" ? (
              <div className={Style.situation}>
                {" "}
                وضعیت سفارش: {" "}
                <h3 className={Style.completed}>تکمیل شده است </h3>{" "}
              </div>
            ) : (
              <div className={Style.situation}>
                {" "}
                وضعیت سفارش: <h3 className={Style.cancled}>
                  کنسل شده است{" "}
                </h3>{" "}
              </div>
            )}
          </li>
          <li className={Style.EachPart__li}>
            <p
              onClick={() => FactorListHandler(item.id)}
              className={Style.OrderList}
            >
              لیست محصولات سفارش داده شده
            </p>
          </li>
          <li className={Style.EachPart__li__price}>
            <FontAwesomeIcon icon={faMoneyBillWave} /> مبلغ کل:{" "}
            <p>{separate(item.cart)} تومان</p>
          </li>
          <li className={Style.EachPart__li__price}>
            <FontAwesomeIcon style={{color:"#d81515"}} icon={faMinus} /> کارمزد:{" "}
            <p>{separate(item.cart_fee)} تومان</p>
          </li>
        </ul>
      );
    });
  }

  const setOrderByDateHandler = () => {
    getOrderRepoart(selectedDayRange);
  };

  return (
    <div className={Style.ComponenHolder}>
      <Modal
        show={purchased}
        modalClose={() => setPurchased(false)}
        translate={40}
      >
        <Factor orderID={orderID} data={orderListDetails} />
      </Modal>
      <div className={Style.DatePickerHolder}>
        <div>
          <DatePickerInRange
            minimumDate={minimumDate}
            maximumDate={maximumDate}
            placeholder={"بازه زمانی خودرا مشخص کنید"}
            selectedDayRange={selectedDayRange}
            setSelectedDayRange={setSelectedDayRange}
          />
        </div>
        <span onClick={setOrderByDateHandler}>
          <FontAwesomeIcon icon={faSearch} />
        </span>
      </div>
      {loadingHandler}
    </div>
  );
};

export default OrderHistory;
